// extracted by mini-css-extract-plugin
export var card = "_l8-5";
export var cardSelected = "_l8-4";
export var image = "_l8-3";
export var modal = "_l8-0";
export var modalContent = "_l8-1";
export var table = "_l8-2";